export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'surface',
		label: 'Surface Area',
		selector: '& .surface'
	},
	{
		name: 'body',
		label: 'Body Text',
		selector: '& .body'
	},
	{
		name: 'image',
		label: 'Image',
		selector: '& .image'
	},
	{
		name: 'author',
		label: 'Author Name Text',
		selector: '& .author'
	},
	{
		name: 'jobTitle',
		label: 'Job Title Text',
		selector: '& .job-title'
	},
	{
		name: 'company',
		label: 'Company Name Text',
		selector: '& .company'
	}
]